import './origins.scss';

import { OriginThumbnail } from '../../utils/origin_thumbnail'
import { NEW_ADMIN_URL } from 'environment';

angular
.module('app.views')
.config(($routeProvider) => {
    $routeProvider
    .when('/origins/:id', {
        template: require('./origin.html'),
        controller: 'OriginController',
        controllerAs: '$ctrl'
    });
})
.controller('OriginController', function(Origin, $location, $modal, $routeParams, $scope, $http, $q, $window){
    "ngInject"

    $scope.newAdminURL = NEW_ADMIN_URL;

    const load = () => {
      return Origin.get(
          { id: $routeParams.id },
          data => {
              this.origin = data;
              OriginThumbnail($http, $q, this.origin.name).then((url) => this.origin_thumbnail = url);
          },
          err => {
              console.error(err);
          }
      );
    }
    this.loading = true;
    load().$promise.finally(() => this.loading = false);

    this.terminate = () => {
        $modal.open({
          template: require('./confirm_termination.html'),
          controller: 'ConfirmTerminationController',
          size: 'lg',
          backdrop: 'static',
          resolve: {
            broadcast_count: () => this.origin.broadcasts.length,
            origin: () => this.origin.name,
            total_viewer_count: () => this.totalViewerCount(),
          }
        }).result.finally(() => load());
    }

    this.drain = () => {
        if ($window.confirm(`Are you sure you wish to drain origin "${this.origin.name}"?`)) {
            Origin.drain(
                { id: this.origin.name },
                {},
                () => { },
                (err) => {
                    console.error(err);
                    alert('There was an error draining the origin.');
                }
            ).$promise.finally(load);
        }
    }

    this.totalViewerCount = () => _.reduce(_.map(this.origin.broadcasts, b => b.total_active_viewer_count), (m, n) => m + n, 0);
});




// WEBPACK FOOTER //
// ./views/origins/origin_controller.js